import React, { FC, ReactNode } from 'react';
import { css } from '@emotion/css';

interface BagetProps {
  children: ReactNode;
}

const Baget: FC<BagetProps> = (props) => {
  const { children } = props;

  return <div className={styles.root}>{children}</div>;
};

const styles = {
  root: css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: #fde69b;
    border-radius: 6px;
    padding: 4px 12px;
    vertical-align: middle;
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #ae8704;
  `,
};

export default Baget;
